import apiFetch from '../../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `dossier/purchase/${dossierId}`, method: 'GET', token: token })
}
